/*eslint-disable*/
import api from '../'

class chainsBonusGameApi {
    // POST: chain
    static getChainByRequest (params) {
        return api.axios.get('/chainBonusGameByRequest', {params}).then(response => response.data);
    }
}

export default chainsBonusGameApi;
